import { render, staticRenderFns } from "./chatPedido.vue?vue&type=template&id=01f97f29&scoped=true&"
import script from "./chatPedido.vue?vue&type=script&lang=js&"
export * from "./chatPedido.vue?vue&type=script&lang=js&"
import style0 from "./chatPedido.vue?vue&type=style&index=0&id=01f97f29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f97f29",
  null
  
)

export default component.exports